import api from '../api-methods'

const proxyAi = process.env.VUE_APP_ENV === 'local' ? '/proxy_ai' : process.env.VUE_APP_ML
const proxyAdmin = process.env.VUE_APP_ENV === 'local' ? '/proxy_admin' : process.env.VUE_APP_ADMIN

const ai = {
  // 生产ai看相报告
  getAiFaces: payload => {
    return api.post(proxyAi + '/v1/face2job', payload,{'Content-Type':'multipart/form-data'})
  },
  //查看报告
  getAiFacesReport: payload => {
    return api.post(proxyAdmin + '/v1/configuration/hack', payload)
  },
}

export default ai
